import React, { Component } from "react";
import { Row, Col, Input, InputNumber } from "antd";
import { withRouter } from "react-router-dom";
class InvitationHeader extends Component {
  formRef = React.createRef();
  state = {
    title: this.props.title,
    tendername: this.props.tendername,
    department: this.props.department,
    typename: this.props.typename,
    purchasemethod: this.props.purchasemethod,
    budget: this.props.budget,
    statusname: this.props.statusname
  };
  render() {
    return (
      <div className="mainContainer">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <div className="HeaderLabel" style={{ marginBottom: 15 }}>
              {this.state.title} | {this.state.tendername}
            </div>
          </Col>
          <Col span={12}>
            <Row justify="end" gutter={[16, 16]}>
              <div className="MidLabel" style={{ marginBottom: 15 }}>
                Урилгын төлөв: {this.state.statusname}
              </div>
            </Row>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <div className="Label" style={{ marginBottom: 5 }}>
              Захиалагч
            </div>
            <Input disabled size="middle" value={this.state.department} />
          </Col>
          <Col span={6}>
            <div className="Label" style={{ marginBottom: 5 }}>
              Төрөл
            </div>
            <Input disabled size="middle" value={this.state.typename} />
          </Col>
          <Col span={6}>
            <div className="Label" style={{ marginBottom: 5 }}>
              Худалдан авах ажиллагааны арга
            </div>
            <Input disabled size="middle" value={this.state.purchasemethod} />
          </Col>
          <Col span={6}>
            <div className="Label" style={{ marginBottom: 5 }}>
              Төсөв
            </div>
            <InputNumber
              placeholder="___._"
              style={{ width: "100%" }}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              defaultValue={this.state.budget}
              disabled
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(InvitationHeader);
